import $ from 'jquery';
/*eslint-disable */
import slick from 'slick-carousel';
/* eslint-enable */
import AOS from 'aos';
import SimpleLightbox from 'simple-lightbox';
import Analytics from './js/analytics';
import DraggableNav from './js/draggableNav';

export default class Feature {
  constructor() {
    this.example = 'example';
    this.testMode = false;
    this.bodyEl = document.body;
    this.mainEl = document.getElementById('main');
  }

  init() {
    this.activePage = this.mainEl.getAttribute('data-page-name');
    this.example = 'initialized';
    this.initListeners();
    this.initAnimation();
    this.initLightbox();
    this.initAnalytics();
    this.initPicSlider();
    this.initNav();
    this.setPopUp();
  }

  setPopUp() {
    if (document.querySelectorAll('.bloomies-popup-outer').length) {
      const popupEl = document.querySelectorAll('.bloomies-popup-outer')[0];

      // reset popup
      popupEl.classList.remove('hide');

      // close the popup
      this.closePopup();

      // list for the overlay click
      document.querySelectorAll('.bloomies-popup-bg')[0].addEventListener('click', () => {
        this.closePopup();
      });

      // listen for close button click
      document.querySelectorAll('.bloomies-x')[0].addEventListener('click', () => {
        this.closePopup();
      });

      // open in 10 seconds
      if (this.getCookie('bloomies-popup') !== 'true') {
        setTimeout(() => this.openPopup(), 3000);
      }
    }
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  }

  getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  openPopup() {
    this.setCookie('bloomies-popup', 'true', 7);
    this.bodyEl.classList.remove('popup-closed');
    this.bodyEl.classList.add('popup-open');
    this.utag.fireLinkTag('bloomies-popup-open');
  }

  closePopup() {
    this.bodyEl.classList.remove('popup-open');
    this.bodyEl.classList.add('popup-closed');
    this.utag.fireLinkTag('bloomies-popup-close');
  }


  initNav() {
    const bloomiesNav = document.querySelector('.bloomies-nav');

    if (bloomiesNav) {
      const d = new DraggableNav();
      d.init();
    }

    const bloomiesNavCell = bloomiesNav.querySelector('.cell');
    const offset = document.body.offsetWidth - bloomiesNavCell.offsetWidth;
    if (this.activePage === 'bloomies-university-village' || this.activePage === 'bloomies-the-grove') {
      bloomiesNavCell.style.transform = `translate3d(${offset}px, 0px, 0px)`;
    }
  }


  initPicSlider() {
    $('.pic-slider').each(function () {
      $(this).find('ul li').css('display', 'block');
      $(this).find('ul li').css('visibility', 'visible');
      $(this).find('ul').slick({
        autoplay: true,
        infinite: true,
      });
    });
  }


  checkPageOffset(pageOffset = window.pageYOffset) {
    const stickyNav = document.getElementById('bloomies-sticky-nav');
    if (pageOffset > document.getElementById('bloomies-nav').offsetTop) {
      stickyNav.classList.add('active');
    } else {
      stickyNav.classList.remove('active');
    }
  }

  initListeners() {
    document.querySelectorAll('.bloomies-lightbox').forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        this.showLightbox(element.getAttribute('data-lightbox-image'));
      });
    });
  }

  initAnalytics() {
    this.utag = new Analytics();
    const pageViewTag = this.activePage;
    setTimeout(() => {
      this.utag.fireViewTag(pageViewTag);
    }, 1000);
  }

  initAnimation(w = window.innerWidth) {
    console.log(w);
    AOS.init({
      // disable: () => w < 1024,
      offset: 220,
      duration: 500,
      easing: 'ease-in-out',
      anchorPlacement: 'center-bottom',
      delay: 0,
    });
  }

  initLightbox() {
    SimpleLightbox.defaults = {
      // add custom classes to lightbox elements
      elementClass: '',
      elementLoadingClass: 'slbLoading',
      htmlClass: 'slbActive',
      closeBtnClass: ' lightbox-close',
      nextBtnClass: ' lightbox-next',
      prevBtnClass: ' lightbox-prev',
      loadingTextClass: '',

      // customize / localize controls captions
      closeBtnCaption: 'Close',
      nextBtnCaption: '',
      prevBtnCaption: '',
      loadingCaption: 'Loading...',

      bindToItems: true, // set click event handler to trigger lightbox on provided $items
      closeOnOverlayClick: true,
      closeOnEscapeKey: true,
      nextOnImageClick: true,
      showCaptions: true,

      captionAttribute: 'title', // choose data source for library to glean image caption from
      urlAttribute: 'href', // where to expect large image

      startAt: 0, // start gallery at custom index
      loadingTimeout: 100, // time after loading element will appear

      appendTarget: 'body', // append elsewhere if needed

      beforeSetContent: null, // convenient hooks for extending library behavoiur
      beforeClose: null,
      beforeDestroy: null,

      videoRegex: new RegExp(/youtube.com|vimeo.com/), // regex which tests load url for iframe content
    };
  }

  showLightbox(img) {
    SimpleLightbox.open({
      items: [img],
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_bcom_v2/package/src/bloomies.js